// src/auth/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useOrg, ORG_CHOOSER_PATH } from '../org/OrgContext';

export default function ProtectedRoute(){
  const { user } = useAuth();
  const { org } = useOrg();
  const loc = useLocation();

  if(!user) return <Navigate to="/login" replace state={{ from: loc }} />;

  // Let the chooser page itself be accessible without an org selected
  const isChooser = loc.pathname === ORG_CHOOSER_PATH;
  if(!org && !isChooser) return <Navigate to={ORG_CHOOSER_PATH} replace />;

  return <Outlet/>;
}
